export { default } from './AppInfoScreen';
export * from './AppInfoScreen';
